import { ConcreteEncodable } from "./ConcreteEncodable";

import { TenorToValueAndFixingDateImplEncoder } from "../../encoder/TenorToValueAndFixingDateImplEncoder";

import * as CubiqTS from "../../index";
import { TenorToValueAndFixingDate } from "../TenorToValueAndFixingDate";

export class TenorToValueAndFixingDateImpl
  extends ConcreteEncodable
  implements TenorToValueAndFixingDate
{
  public static enType: string = "com.bcdfx.model.calendar.TenorToValueAndFixingDateImpl";

  /*FID=1*/
  public tenor: CubiqTS.Tenor;
  /*FID=2*/
  public valueDate: CubiqTS.StandardDate | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=101*/
  public fixingDate: CubiqTS.StandardDate | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = TenorToValueAndFixingDateImplEncoder.Instance;
    this.setEncodableType(TenorToValueAndFixingDateImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "TenorToValueAndFixingDateImpl[" +
      "tenor=" +
      this.tenor +
      "valueDate=" +
      this.valueDate +
      "messageId=" +
      this.messageId +
      "fixingDate=" +
      this.fixingDate +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
